import {UuserService} from "../service/UuserService";
import 'react-toastify/dist/ReactToastify.css';
import {Toolbar} from "primereact/toolbar";
import {Button} from "primereact/button";
import FileUploader from "./fileUploader/FileUploader";
import React, {useState} from "react";
import FileService from "../service/FileService";
import GeneralUtils from "../utils/GeneralUtils";


const ProfilePhotoChange = (props) => {
    const {src} = props;
    const fileService = new FileService();
    const [imageFile, setImageFile] = useState();

    const upload = () =>{
        fileService.upload(getImageForm()).then((response)=>{
            if (!GeneralUtils.isNullOrEmpty(response)){
                if(props.closeDialog){
                    props.closeDialog();
                }
            } else{
                setImageFile(null);
            }
        });
    }

    const getImageForm = () => {
        const imageForm = new FormData();
        imageForm.append('file', imageFile);
        imageForm.append('name', imageFile.name);
        imageForm.append('path', "user");
        imageForm.append('id', GeneralUtils.getUserId());
        return imageForm;
    }

    return (
        <>
            <Toolbar end={
                <Button className="p-inputtext-sm" label="Kaydet" onClick={() => upload()}/>
            } className="mt-2 mb-2"/>
            <FileUploader type="image" name="image" accept=".gif,.jpg,.jpeg,.png,.webp" src={src}
                          onUpload={file => setImageFile(file)}
                          label="Profilinize güzel bir resminizi ekleyin."/>
        </>
    )
}

export default ProfilePhotoChange;